var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV5Tourisme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -33.23,
    y: -30.17,
    width: 129.96,
    height: 129.96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.34,35.8a7.78,7.78,0,0,0-7.24-7.68,1.19,1.19,0,0,1-1.24-.95c-.4-1.19-.9-2.35-1.37-3.52a3.46,3.46,0,0,0-3.64-2.34c-.86,0-1.72,0-2.56,0V17.65c1.39,0,2.69,0,4,0a4,4,0,0,0,4.16-4.25q0-3.72,0-7.44A4,4,0,0,0,46.3,1.84q-5.49,0-11,0a4,4,0,0,0-4.23,4.29c0,2.27,0,4.55,0,6.82,0,3.17,1.52,4.68,4.74,4.7,1.12,0,2.24,0,3.4,0v3.66H36.85A4.59,4.59,0,0,0,32,24.58c-.36.9-.56,1.86-.95,2.74a1.32,1.32,0,0,1-.9.73c-3.87.05-7.74,0-11.6,0l.2-.34c-.56-.47-1.13-1.32-1.69-1.32s-1.15.83-1.73,1.3l.21.36H13.32a7.81,7.81,0,0,0-8.13,7.84q-.12,9.09,0,18.18A7.88,7.88,0,0,0,13,62q18.81,0,37.61,0a7.83,7.83,0,0,0,7.75-7.72q.06-9.21,0-18.42m-42.43-.14a15,15,0,0,1-2,0,15.1,15.1,0,0,1-2,0,1.78,1.78,0,0,1-1.69-1.87A1.7,1.7,0,0,1,11.83,32,26.26,26.26,0,0,1,16,32a1.69,1.69,0,0,1,1.62,1.79,1.75,1.75,0,0,1-1.7,1.85M37.45,15.45a3.92,3.92,0,0,1-3.91-3.95c0-1.17,0-2.35,0-3.52a3.88,3.88,0,0,1,4-3.95c1.09,0,2.18,0,3.28,0S43,4,44.1,4A3.86,3.86,0,0,1,48,8c0,1.17,0,2.35,0,3.52a3.89,3.89,0,0,1-3.87,4c-2.22.06-4.45.06-6.67,0m3.1,42.46A12.89,12.89,0,1,1,53.38,45,13,13,0,0,1,40.55,57.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.45,36.85A8.14,8.14,0,1,0,48.66,45a8.19,8.19,0,0,0-8.21-8.15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV5Tourisme);
export default __webpack_public_path__ + "static/media/v5_tourisme.7cb45dca1644a5d0b6b68cbddaa9c7d7.svg";
export { ForwardRef as ReactComponent };